import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { GlobalButtonComponent, MenuItemComponent } from 'declarabid-library';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { MenuItem } from 'primeng/api';
import {
  MenuService,
  SidebarMenuItem,
} from '../../../core/services/menu.service';
import { MenuModule } from 'primeng/menu';
import { UsersService } from '../../../features/users/services/users.service';
import { AuthService } from '../../../features/auth/services/auth.service';
import { UserRole } from '../../../core/models/auth.model';
import { OverlayNotificationsComponent } from '../overlay-notifications/overlay-notifications.component';
import { BrandAssetsService } from '../../../features/config-system/services/brand-assets.service';
import { SkeletonModule } from 'primeng/skeleton';
import { OverlayNotificationsService } from '../../services/overlay-notifications.service';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-navigation-bar',
  imports: [
    RouterModule,
    GlobalButtonComponent,
    AvatarModule,
    AvatarGroupModule,
    MenuItemComponent,
    MenuModule,
    OverlayNotificationsComponent,
    SkeletonModule,
    Popover,
  ],
  templateUrl: './navigation-bar.component.html',
  styleUrl: './navigation-bar.component.scss',
})
export class NavigationBarComponent implements OnInit {
  @ViewChild('op') popover!: Popover;
  public readonly _usersService = inject(UsersService).currentUser();
  protected readonly notificationService = inject(OverlayNotificationsService);
  private readonly menuService = inject(MenuService);
  public items!: SidebarMenuItem[];
  readonly router = inject(Router);
  private readonly _authService = inject(AuthService);
  private readonly brandAssets = inject(BrandAssetsService);
  public loadingLogo = signal<boolean>(true);
  public logoUrl = this.brandAssets.logoUrl;

  options: MenuItem[] = [
    // {
    //   label: $localize`Mi perfil`,
    //   icon: 'pi pi-user',
    //   command: () => this.goToProfile(),
    // },
    {
      label: $localize`Cerrar sesión`,
      icon: 'pi pi-sign-out',
      command: () => this._authService.logout(),
    },
  ];
  public routeUser = inject(UsersService).userRoutes();
  public currentUserRole = signal<UserRole | undefined>(undefined);
  readonly UserRole = UserRole;
  public hasUnread = this.notificationService.hasUnread;

  // goToProfile() {}

  ngOnInit(): void {
    this.currentUserRole.set(this._usersService.role_value as UserRole);
    this.menuService.setMenuItems(this._usersService.role_value);
    this.menuService.getMenuItems().subscribe((menuItems) => {
      this.items = menuItems;
    });
    this.loadingLogo.set(true);
    this.brandAssets.load().subscribe({
      next: () => this.loadingLogo.set(false),
      error: () => this.loadingLogo.set(false),
    });
  }

  protected onShow() {
    document.body.classList.add('no-scroll');
    this.notificationService.forceRefresh(this._usersService.id);
  }

  public onHide() {
    document.body.classList.remove('no-scroll');
    document.body.style.paddingRight = '';
  }

  protected show(event: Event) {
    this.popover.toggle(event);
  }
}
